import { createRoutesFromElements, Route } from 'react-router-dom'
import {
  CategoryPage,
  HomePage,
  Layout,
  ProjectAdminPage,
  ProjectUsersAdminPage,
  RequestAccessPage,
  TenantsPage
} from '../pages'

const routes = createRoutesFromElements(
  <Route path='/' element={<Layout />}>
    <Route index element={<HomePage />} />
    <Route path='myprojects' element={<TenantsPage />} />
    <Route path=':tenantUrlSlug/:affiliationUrlSlug?/'>
      <Route path='project-admin' element={<ProjectAdminPage />} />
      <Route path='project-users' element={<ProjectUsersAdminPage />} />
      <Route path='request-access' element={<RequestAccessPage />} />
      <Route path=':categoryUrlSlug?/:id?' element={<CategoryPage />} />
    </Route>
  </Route>
)

export { routes }
